import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";

// Using relative URL for API calls
const API = "/api";

export default function ProtectedRoute({ children }) {
  const navigate = useNavigate();
  const location = useLocation();
  
  // If user data was passed from AuthCallback, skip auth check
  const [isAuthenticated, setIsAuthenticated] = useState(
    location.state?.user ? true : null
  );

  useEffect(() => {
    // Skip if already authenticated via state
    if (location.state?.user) {
      setIsAuthenticated(true);
      return;
    }

    const checkAuth = async () => {
      const token = localStorage.getItem("auth_token");
      
      if (!token) {
        setIsAuthenticated(false);
        navigate("/login", { replace: true });
        return;
      }

      try {
        const response = await fetch(`${API}/auth/me`, {
          headers: { Authorization: `Bearer ${token}` },
          
        });

        if (!response.ok) {
          throw new Error("Not authenticated");
        }

        const userData = await response.json();
        localStorage.setItem("user", JSON.stringify(userData));
        setIsAuthenticated(true);
      } catch (error) {
        localStorage.removeItem("auth_token");
        localStorage.removeItem("user");
        setIsAuthenticated(false);
        navigate("/login", { replace: true });
      }
    };

    checkAuth();
  }, [navigate, location.state]);

  // Loading state
  if (isAuthenticated === null) {
    return (
      <div className="min-h-screen bg-[#0D0D0D] flex items-center justify-center">
        <Loader2 className="w-8 h-8 animate-spin text-[#14A800]" />
      </div>
    );
  }

  // Not authenticated
  if (isAuthenticated === false) {
    return null;
  }

  // Authenticated
  return children;
}
